// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__+yYmw","overlay":"styles_overlay__YxYSc"};